<template>
  <div>
    <el-row>
      <el-col :span="10">
        <span>收费类型: </span>
      </el-col>
      <el-col :span="14">
        <span>{{ocfTypeDescription}}</span>
      </el-col>
    </el-row>
    <!--<el-row v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.memberCard.value">
      <el-col :span="10">
        <span>购买年度: </span>
      </el-col>
      <el-col :span="14">
        <span>{{membershipYearDescription}}</span>
      </el-col>
    </el-row>-->
    <el-row v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value">
      <el-col :span="10">
        <span>兑换物品: </span>
      </el-col>
      <el-col :span="14">
        <span>{{bpeItemName}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.academicPlanning.value">
      <el-col :span="10">
        <span>学业规划类型: </span>
      </el-col>
      <el-col :span="14">
        <span>{{ocfSubTypeDescription}}</span>
      </el-col>
    </el-row>
    <div v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.topUpBalance.value">
      <el-row>
        <el-col :span="10">
          <span>余额充值优惠：</span>
        </el-col>
        <el-col :span="14">
          <span>{{getGiftBalanceItemText()}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <span>充值金额：</span>
        </el-col>
        <el-col :span="14">
          <span>{{dataModel.amount | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <span>赠送金额：</span>
        </el-col>
        <el-col :span="14">
          <span v-if="dataModel.giftAmount != null">{{dataModel.giftAmount | toCurrency}}</span>
          <span v-else>{{0 | toCurrency}}</span>
        </el-col>
      </el-row>
    </div>
    <el-row v-if="dataModel.type != this.GLOBAL.otherCollectFeeType.topUpBalance.value">
      <el-col :span="10">
        <span>价格：</span>
      </el-col>
      <el-col :span="14">
        <span>{{dataModel.amount | toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.watchVideos.value">
      <el-col :span="10">
        <span>数量：</span>
      </el-col>
      <el-col :span="14">
        <span>{{dataModel.quantity | toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.videoPackage.value">
      <el-col :span="10">
        <span>课程：</span>
      </el-col>
      <el-col :span="14">
        <span>{{courseName}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10">
        <span>总计：</span>
      </el-col>
      <el-col :span="14">
        <span>{{dataModel.totalPrice | toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row
      v-show="!!dataModel.balanceCost"
      class="cs-redLabel"
    >
      <el-col :span="10">
        <span>使用余额：</span>
      </el-col>
      <el-col :span="14">
        <span>{{(-1 * dataModel.balanceCost) | toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row
      v-show="!!dataModel.bonusPointPrice"
      class="cs-redLabel"
    >
      <el-col :span="10">
        <span>使用积分：</span>
      </el-col>
      <el-col :span="14">
        <span>{{(-1 * dataModel.bonusPointPrice) | toCurrency}}</span>
        <span>({{dataModel.bonusPointCost}})</span>
      </el-col>
    </el-row>
    <el-row
      v-show="!!dataModel.cashDecreasedAmount"
      class="cs-redLabel"
    >
      <el-col :span="10">
        <span>使用现金减：</span>
      </el-col>
      <el-col :span="14">
        <span>{{(-1 * dataModel.cashDecreasedAmount) | toCurrency}}</span>
      </el-col>
    </el-row>
    
    <el-row
      v-show="!!dataModel.paidAmount"
      class="cs-redLabel"
    >
      <el-col :span="10">
        <span>已付金额：</span>
      </el-col>
      <el-col :span="14">
        <span>{{(-1 * dataModel.paidAmount) | toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="!!dataModel.excessAmount">
      <el-col :span="10">
        <span>超出金额：</span>
      </el-col>
      <el-col :span="14">
        <span>{{dataModel.excessAmount | toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10">
        <span>应付价格：</span>
      </el-col>
      <el-col :span="14">
        <span>{{dataModel.paymentAmount | toCurrency}}</span>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import { getStudentCurrentTermCourses } from "@/service/student.service";

export default {
  props: {
    data: {
      priceSettings: Object,
      bonusPointExchangeItems: Array,
      giftBalanceList: Array,
      otherCollectFeeTypes: Array,
      memberShipYears: Array,
      ocfType: Number,
      subType: Number,
      studentId: Number,
      phone: String,
      comment: String,
      amount: Number,
      quantity: Number,
      totalPrice: Number,
      paymentAmount: Number,
      balanceCost: Number,
      bonusPointCost: Number,
      bonusPointPrice: Number,
      bpeItemId: Number,
      paidAmount: Number,
      excessAmount: Number,
      cashDecreasedAmount: Number,
      giftBalanceId: Number,
      giftAmount: Number,
      courseId: Number
    }
  },
  data() {
    return {
      priceSettings: {
        normalVideoPrice: 0,
        supplementVideoPrice: 0,
        membershipCardPrice: 0,
        paymentCommissionRate: 0,
        renewMembershipCardPrice: 0,
        extendMembershipCardPrice:0,
      },
      bonusPointExchangeItems: [],
      giftBalanceList: [],
      otherCollectFeeTypes: [],      
      memberShipYears: [],
      courseList: [],
      dataModel: {
        type: 0,
        year: 0,
        subType: null,
        studentId: null,
        phone: null,
        comment: null,
        amount: 0,
        quantity: 0,
        totalPrice: 0,
        paymentAmount: 0,
        balanceCost: 0,
        bonusPointCost: 0,
        bonusPointPrice: 0,
        bpeItemId: null,
        paidAmount: 0,
        excessAmount: 0,
        cashDecreasedAmount: 0,
        giftBalanceId: null,
        giftAmount: null,
        courseId: null
      }
    };
  },
  computed: {
    ocfTypeDescription: function() {
      let ocfType = this.__findOtherCollectFeeTypeByValue(this.dataModel.type);
      return !!ocfType ? ocfType.description : null;
    },
    membershipYearDescription:function(){
      let feeYear = this.__findMemberShipYearByValue(this.dataModel.feeYear);
      return !!feeYear ? feeYear.description : null;
    },
    ocfSubTypeDescription: function() {
      if (!this.dataModel.subType) return null;

      let result = null;
      switch (this.dataModel.subType) {
        case 1:
          result = "单次";
          break;
        case 2:
          result = "无限次";
          break;
      }

      return result;
    },
    bpeItemName: function() {
      let bpeItem = this.__findBonusPointExchangeItem(this.dataModel.bpeItemId);
      return !!bpeItem ? bpeItem.ItemName : null;
    },
    courseName() {
      var course = this.courseList.find(item => item.Id === this.dataModel.courseId);
      return !!course ? course.Name : String.empty;
    }
  },
  created() {
    this.loadDataFromProps();
  },
  methods: {
    async loadStudentCurrentTermCoursesFromServer(
      studentId = this.dataModel.studentId
    ) {
      if (!studentId) return null;

      let result = await getStudentCurrentTermCourses(this.GLOBAL.enumNormalCourseCategory.OfflineCourse, studentId);
      return !!result && result.success ? result.data : [];
    },


    async loadDataFromProps(data = this.data) {
      if (!!data) {
        if (!!data.priceSettings) {
          this.priceSettings.normalVideoPrice =
            data.priceSettings.normalVideoPrice;
          this.priceSettings.supplementVideoPrice =
            data.priceSettings.supplementVideoPrice;
          this.priceSettings.membershipCardPrice =
            data.priceSettings.membershipCardPrice;
          this.priceSettings.paymentCommissionRate =
            data.priceSettings.paymentCommissionRate;
          this.priceSettings.renewMembershipCardPrice =
            data.priceSettings.renewMembershipCardPrice;
          this.priceSettings.extendMembershipCardPrice =
            data.priceSettings.extendMembershipCardPrice;
        } else {
          this.priceSettings.normalVideoPrice = 0;
          this.priceSettings.supplementVideoPrice = 0;
          this.priceSettings.membershipCardPrice = 0;
          this.priceSettings.paymentCommissionRate = 0;
          this.priceSettings.renewMembershipCardPrice = 0;
          this.priceSettings.extendMembershipCardPrice = 0;

        }

        if (!!data.bonusPointExchangeItems)
          this.bonusPointExchangeItems = data.bonusPointExchangeItems;
        else this.bonusPointExchangeItems = [];

        if (!!data.giftBalanceList){
          this.giftBalanceList = data.giftBalanceList;
        }else{
          this.giftBalanceList = [];
        }

        if (!!data.otherCollectFeeTypes)
          this.otherCollectFeeTypes = data.otherCollectFeeTypes;
        else this.otherCollectFeeTypes = [];

        if(!!data.memberShipYears){
          this.memberShipYears = data.memberShipYears;
        }else this.memberShipYears = [];
        
        this.dataModel.type = data.ocfType;
        this.dataModel.feeYear = data.feeYear;
        this.dataModel.subType = data.subType;
        this.dataModel.studentId = data.studentId;
        this.dataModel.phone = data.phone;
        this.dataModel.comment = data.comment;
        this.dataModel.amount = data.amount;
        this.dataModel.quantity = data.quantity;
        this.dataModel.totalPrice = data.totalPrice;
        this.dataModel.paymentAmount = data.paymentAmount;
        this.dataModel.balanceCost = data.balanceCost;
        this.dataModel.cashDecreasedAmount = data.cashDecreasedAmount;
        this.dataModel.bonusPointCost = data.bonusPointCost;
        this.dataModel.bonusPointPrice = data.bonusPointPrice;
        this.dataModel.bpeItemId = data.bpeItemId;
        this.dataModel.paidAmount = data.paidAmount;
        this.dataModel.excessAmount = data.excessAmount;
        this.dataModel.giftBalanceId = data.giftBalanceId;
        this.dataModel.giftAmount = data.giftAmount;
        this.dataModel.courseId = data.courseId;

        if (this.dataModel.type == this.GLOBAL.otherCollectFeeType.videoPackage.value) {
          this.courseList = await this.loadStudentCurrentTermCoursesFromServer(data.studentId);
        }
      } else {
        this.initPriceSettings();
        this.initDataModel();
      }
    },
    initPriceSettings() {
      this.priceSettings.normalVideoPrice = 0;
      this.priceSettings.supplementVideoPrice = 0;
      this.priceSettings.membershipCardPrice = 0;
      this.priceSettings.paymentCommissionRate = 0;
      this.priceSettings.renewMembershipCardPrice = 0;
      this.priceSettings.extendMembershipCardPrice = 0;

    },
    initDataModel(
      ocfType = this.otherCollectFeeTypes.length > 0
        ? this.otherCollectFeeTypes[0].value
        : 0,
      feeYear = this.memberShipYears.length > 0 ? this.memberShipYears[0].value : 0
    ) {
      this.dataModel.type = ocfType;
      this.dataModel.feeYear = feeYear;
      this.dataModel.subType = null;
      this.dataModel.studentId = null;
      this.dataModel.phone = null;
      this.dataModel.comment = null;
      this.dataModel.amount = 0;
      this.dataModel.quantity = 0;
      this.dataModel.totalPrice = 0;
      this.dataModel.paymentAmount = 0;
      this.dataModel.balanceCost = 0;
      this.dataModel.bonusPointCost = 0;
      this.dataModel.bonusPointPrice = 0;
      this.dataModel.bpeItemId = null;
      this.dataModel.paidAmount = 0;
      this.dataModel.excessAmount = 0;
      this.dataModel.cashDecreasedAmount = 0;
      this.dataModel.giftBalanceId = null;
      this.dataModel.giftAmount = null;
      this.dataModel.courseId = null;
    },
    __findOtherCollectFeeTypeByValue(typeValue) {
      let result = null;
      for (let i = 0; i < this.otherCollectFeeTypes.length; i++) {
        let field = this.otherCollectFeeTypes[i];
        if (field.value == typeValue) {
          result = field;
          break;
        }
      }
      return result;
    },
    __findMemberShipYearByValue(yearValue){
      let result = null;
      for(let i = 0 ; i < this.memberShipYears.length; i ++){
        let field = this.memberShipYears[i];
        if(field.value == yearValue){
          result = field;
          break;
        }
      }
      return result;
    },
    __findBonusPointExchangeItem(id) {
      let result = null;
      for (let i = 0; i < this.bonusPointExchangeItems.length; i++) {
        let field = this.bonusPointExchangeItems[i];
        if (field.Id == id) {
          result = field;
          break;
        }
      }
      return result;
    },
    __findGiftBalanceItem() {
      return this.giftBalanceList.find(i => i.Id == this.dataModel.giftBalanceId);
    },
    getGiftBalanceItemText(){
      let item = this.__findGiftBalanceItem();
      if (!!item){
        return item.FullName;
      }
      return "";
    }
  },
  watch: {
    data: function(newVal) {
      this.loadDataFromProps(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/otherCollectFee/ocfWorkflowInfo.vue